import React from 'react';
import { Title, Wrapper } from './styled';

const Banner = () => (
  <Wrapper data-cy="top-banner">
    <Title>SAVE UP TO 70%* - FREE SHIPPING</Title>
  </Wrapper>
);

export default Banner;
